<dynamic-form
  [group]="group"
  [serviceName]="'TrackInvitationsService'"
  [loading]="loading"
  [visuals]="visuals"
  [genericVisuals]="genericVisuals"
  [formErrors]="formErrors"
  #form="dynamicForm"
  (submit)="submit($event)"
  (modalOutput)="handleModalOutput($event)"
  (formChanges)="handleFormChanges($event)"
>
</dynamic-form>

<base-table-layout
  [records]="grid"
  [footer]="footer"
  [gridActions]="gridActions"
  [hasRowCheckbox]="hasRowCheckbox"
  [settings]="columnSetting"
  [searched]="searched"
  [loading]="loading"
  [downloading]="downloading"
  [checkboxLoading]="checkboxLoading"
  [count]="count"
  [visuals]="visuals"
  [genericVisuals]="genericVisuals"
  (outputMethodHandler)="outputMethodHandler($event)"
  [sortNum]="sortNum"
  [sortDir]="sortDir"
  [secSortNum]="secSortNum"
  [secSortDir]="secSortDir"
  (changeSortHandler)="changeSort($event)"
  [pageSize]="pageSize"
  [pageNum]="pageNum"
  [pageMax]="pageMax"
  (changePageHandler)="changePage($event)"
  (changePageSizeHandler)="changePageSize($event)"
>
</base-table-layout>
